import { DropdownMenu } from '@radix-ui/themes';
import { EllipsisVertical } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';
import { HubertButton } from 'components/HubertUI/HubertButton';

interface Props extends TRuleEditorCommonProps {
  hideDoIf?: boolean;
  onAddDoIf: () => void;
  onAddShowIf: () => void;
}

const AddRuleDropdown = ({ isReadOnly, hideDoIf, onAddDoIf, onAddShowIf }: Props) => {
  const { t } = useTranslation('Templates');

  if (isReadOnly) return null;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <HubertButton variant="default" size="sm" icon={<EllipsisVertical />}>
          {t('question.rules.addRuleButton')}
        </HubertButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content variant="solid">
        {hideDoIf ? null : (
          <DropdownMenu.Item onClick={onAddDoIf}>{t('question.rules.doIfAnswerIs')}</DropdownMenu.Item>
        )}

        <DropdownMenu.Item onClick={onAddShowIf}>{t('question.rules.showThisIf')}</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default AddRuleDropdown;
